import { ArrowIcon } from 'BreetAssets';
import { format } from 'date-fns';

export const CustomHeader = ({
	monthDate,
	customHeaderCount,
	decreaseMonth,
	increaseMonth,
}: {
	monthDate: Date;
	customHeaderCount: number;
	decreaseMonth: VoidFunction;
	increaseMonth: VoidFunction;
}) => (
	<div className='bt_dateRangePicker_calendar_monthheader'>
		{customHeaderCount === 0 ? (
			<button
				type='button'
				className='bt_dateRangePicker_calendar_navbtn'
				onClick={decreaseMonth}
				aria-label='Previous month'
			>
				<ArrowIcon variant='arrowLeft' />
			</button>
		) : (
			<span className='bt_dateRangePicker_calendar_navspacer' />
		)}

		<span className='bt_dateRangePicker_calendar_monthtitle'>{format(monthDate, 'MMMM yyyy')}</span>

		{customHeaderCount === 1 ? (
			<button
				type='button'
				className='bt_dateRangePicker_calendar_navbtn'
				onClick={increaseMonth}
				aria-label='Next month'
			>
				<ArrowIcon variant='arrowRight' />
			</button>
		) : (
			<span className='bt_dateRangePicker_calendar_navspacer' />
		)}
	</div>
);
